import { defineMessages } from '../translate';

/** Split from `settings` so the always-loaded entry chunk carries only these strings. */
export default defineMessages('settings-tabs', {
  tabGeneral: 'General',
  tabBilling: 'Billing',
  tabMembers: 'Members',
  tabWorkflow: 'Workflow',
  tabRituals: 'Rituals',
  tabAi: 'AI',
  tabPolicies: 'Policies',
  tabRoles: 'Roles & Permissions',
  tabIntegrations: 'Integrations',
  tabWebhooks: 'Webhooks',
  tabKnowledge: 'Knowledge',
  tabTrustCenter: 'Trust Center',
  tabDanger: 'Danger zone',
  pageTitle: '{team} · Settings',
  
  
  tabProjects: 'Projects',
  tabNudges: 'Nudges',
  tabConnections: 'Connections',
  tabData: 'Data',
  groupTeam: 'Team',
  groupSpace: 'Space',
  groupPeople: 'People',
  groupWork: 'Work',
  groupMyDay: 'My day',
  groupGovernance: 'Rules & audit',
  groupConnections: 'Connections',
  groupData: 'Data',
  groupDanger: 'Danger zone',
  hintGeneral: 'Name, picture, time zone and team-wide defaults',
  hintBilling: 'Plan, seats and storage — and how to upgrade',
  hintMembers: 'Who is in the team, invitations, roles',
  hintWorkflow: 'Statuses and priorities every project uses',
  hintProjects: 'Your personal projects: open, archive or move to a team',
  hintTeamProjects: 'Archived projects: see them and restore',
  hintRituals: 'Reminders to plan the day and wrap it up',
  hintNudges: 'Gentle prompts about deadlines and logged time',
  hintAi: 'Use AI with your own provider key',
  hintPolicies: 'Rules for approvals, AI and limits',
  hintRoles: 'What each role can do',
  hintIntegrations: 'GitHub, imports and other connected services',
  hintWebhooks: 'For developers: send events to your server',
  hintKnowledge: 'What the AI assistant may search',
  hintTrustCenter: 'History of approvals, decisions and rule changes',
  hintConnections: 'Calendar feed and API / AI-app access',
  hintData: 'Download your tasks, see storage used',
  hintDanger: 'Leave, transfer or delete the team',
  hintPersonalGeneral: 'What this space is, your time zone and start screen',
  hintPersonalBilling: 'Your plan and storage',
  hintPersonalWorkflow: 'Statuses and priorities of your personal projects',
} as const);
